import { concat, uniq, uniqBy } from 'lodash-es'

import { PolicyExcessConfig } from '../state/configuration'
import { Endorsement, ExcessLine } from './types'

export const isExcess = (category: string) => (item: ExcessLine) =>
  item.excessCategory === category

export interface ExcessComparison {
  category: string
  previous: number | undefined
  current: number | undefined
}

export const getMandatoryExcessComparison = (
  previous: ExcessLine[],
  current: ExcessLine[],
): ExcessComparison[] => {
  const excessCategories = uniq(concat(previous, current).map((it) => it.excessCategory))

  return excessCategories.map((it) => ({
    category: it,
    previous: previous.find(isExcess(it))?.mandatoryExcess,
    current: current.find(isExcess(it))?.mandatoryExcess,
  }))
}

export const hasUniqueExcesses = (excesses: ExcessComparison[]) =>
  uniqBy(excesses, (it) => it.current).length > 1 ||
  uniqBy(excesses, (it) => it.previous).length > 1

export const hasExcessChanged = (change: ExcessComparison) =>
  change.previous !== change.current

export const isExcessEndorsement =
  (config: PolicyExcessConfig | undefined) =>
  (endorsement: Endorsement): boolean => {
    return Boolean(config?.endorsements?.some((it) => endorsement.code === it))
  }
